/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer3_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer" | "ReplyListContainerLast_viewer">;
    readonly " $refType": "ReplyListContainer3_viewer";
};
export type ReplyListContainer3_viewer$data = ReplyListContainer3_viewer;
export type ReplyListContainer3_viewer$key = {
    readonly " $data"?: ReplyListContainer3_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer3_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer3_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainerLast_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '5f53dd0bf7ade635a19b9e210eea2b65';
export default node;
